"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getObjectDeepKeyValue_1 = __importDefault(require("./getObjectDeepKeyValue"));
var isType_1 = require("./isType");
var reverseList_1 = __importDefault(require("./reverseList"));
var defaultGroupOptions = {
    by: '',
    limit: 0,
    reversed: false
};
var handleGroupReverse = function (groupedLists, reverse) {
    if (reverse === void 0) { reverse = false; }
    if (reverse && isType_1.isBoolean(reverse)) {
        return groupedLists.map(function (group) { return reverseList_1.default(group); });
    }
    return groupedLists;
};
var groupList = function (list, options) {
    if (options === void 0) { options = defaultGroupOptions; }
    var groupLabels = [];
    if (isType_1.isNilOrEmpty(options)) {
        options = defaultGroupOptions;
    }
    var groupBy = options.by, limit = options.limit;
    if (groupBy && (isType_1.isFunction(groupBy) || isType_1.isString(groupBy))) {
        var groupedList = list
            .reduce(function (prevList, item, idx) {
            var groupLabel = isType_1.isFunction(groupBy)
                ? groupBy(item, idx)
                : getObjectDeepKeyValue_1.default(item, groupBy);
            if (!prevList[groupLabel]) {
                prevList[groupLabel] = [];
            }
            if (!limit || (limit > 0 && prevList[groupLabel].length < limit)) {
                prevList[groupLabel].push(item);
            }
            return prevList;
        }, {});
        // using Set here so the order is preserved and prevent duplicates
        groupLabels = Array.from(new Set(Object.keys(groupedList)));
        return { groupLabels: groupLabels, groupLists: handleGroupReverse(Object.values(groupedList), options.reversed) };
    }
    if (limit && isType_1.isNumber(limit) && (limit > 0)) {
        var groupLabel_1 = 1;
        var groupLists = list
            .reduce(function (prevList, item) {
            if (!prevList[groupLabel_1]) {
                prevList[groupLabel_1] = [];
            }
            prevList[groupLabel_1].push(item);
            if (prevList[groupLabel_1].length === limit) {
                groupLabel_1 += 1;
            }
            return prevList;
        }, {});
        groupLabels = Array.from(new Set(Object.keys(groupLists)));
        return { groupLabels: groupLabels, groupLists: handleGroupReverse(Object.values(groupLists), options.reversed) };
    }
    return { groupLabels: groupLabels, groupLists: handleGroupReverse([list], options.reversed) };
};
exports.default = groupList;
//# sourceMappingURL=groupList.js.map